import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import { CircularProgress, Toast, handleFormSubmissionError } from 'ui/components'
import { ManageInvoicePage } from '~bank-invoices/components/ManageInvoicePage'
import { useDeleteInvoiceSubmittalConfirmation } from '~bank-invoices/hooks/useDeleteInvoiceSubmittalConfirmation'
import { InvoiceSubmittalFormRequest, saveInvoice } from '~bank-invoices/service/saveInvoiceSubmittal'
import { InvoiceSubmittalDetails } from '~bank-invoices/types/Details'
import { ManageInvoiceSubmittalFormType } from '~bank-invoices/types/Manage'

const routeApi = getRouteApi('/_app/invoices/$id/edit')

const EditInvoice = () => {
  const navigate = routeApi.useNavigate()
  const { returnUrl } = routeApi.useSearch()
  const { id } = routeApi.useParams()
  const loaderData = routeApi.useLoaderData()
  const { form, ...appearanceInfo } = loaderData

  const formApi = useForm({
    defaultValues: new ManageInvoiceSubmittalFormType(false, form),
    onSubmit: async ({ value }) => await saveInvoiceSubmittal({ ...value, licenseId: appearanceInfo.licenseId })
  })

  const { mutateAsync: saveInvoiceSubmittal } = useMutation<
    InvoiceSubmittalDetails,
    Error,
    InvoiceSubmittalFormRequest
  >({
    mutationFn: (opts) => saveInvoice(opts),
    onSuccess: (_, request) => {
      if (request?.id) {
        navigate({ to: '/invoices/$id', params: { id: request.id.toString() } })
      }
      Toast.successSmall('Invoice updated')
    },
    onError: (error) => {
      handleFormSubmissionError<ManageInvoiceSubmittalFormType>(error, formApi)
    }
  })

  const { DeleteInvoiceSubmittalConfirmation, onShowInvoiceSubmittalConfirmation } =
    useDeleteInvoiceSubmittalConfirmation({
      onSuccess: () =>
        navigate({ to: '/licenses/$licenseId', params: { licenseId: appearanceInfo?.licenseId.toString() } })
    })

  const onCancel = () => {
    if (returnUrl) {
      navigate({ to: returnUrl as never })
    } else {
      navigate({ to: '/invoices/$id', params: { id: id.toString() } })
    }
  }

  if (!loaderData) return <CircularProgress centered />

  return (
    <>
      <DeleteInvoiceSubmittalConfirmation />
      <ManageInvoicePage
        formApi={formApi}
        appearanceInfo={appearanceInfo}
        pageTitle={`IS-${id}`}
        panelTitle="Edit Invoice Submittal Detail"
        onDelete={() => onShowInvoiceSubmittalConfirmation({ id: Number(id) })}
        onCancel={() => onCancel()}
      />
    </>
  )
}

export default EditInvoice
